import "./exploreStyles.css"
import {Link} from "react-router-dom";

export default function Explore() {
    return(
        <div className="exp">
            <div className="menuI">
                <Link to= {`/posts/${"LATEST"}`}> Latest</Link>
                <Link to= {`/posts/${"TOP_COLLECTED_OPEN_ACTION"}`}>Popular</Link>
                <Link to= {`/posts/${"TOP_REACTED"}`}>Trending</Link>
            </div>
        </div>
    );
}